<mat-card appearance="outlined" class="widget">
    <mat-card-title class="card-title">Solupp- och nedgång</mat-card-title>
    <mat-card-content>
        <div class="sunrise-sunset">
            Uppgång: {{ some_sunrises[0]?.sunrise }}<br>
            Nedgång: {{ some_sunrises[0]?.sunset }}
        </div>
    </mat-card-content>
</mat-card>
